import {
  Box,
  Button,
  Typography,
  Modal,
  Grid,
  TextField,
  Stack,
  Divider,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import { setNavBarInputFields } from "../../app/store/reducer";
import { information } from "../../constants/locationData";

const LocationModal = ({ open, setOpen, currentLocation }) => {
const navBarInputFields = useSelector(
  (state) => state.reducer.navBarInputFields
);
const [searchValue, setSearchValue] = useState(
  navBarInputFields.location || ""
);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    setSearchValue(navBarInputFields.location || "");
  }, [navBarInputFields.location]);

useEffect(() => {
  const savedLocation = sessionStorage.getItem("location");
  if (savedLocation) {
    dispatch(setNavBarInputFields({ location: savedLocation }));
    setSearchValue(savedLocation);
  } else {
    setSearchValue(navBarInputFields.location || "");
  }
}, [navBarInputFields.location]);

  const handleSubmit = () => {
    if (searchValue.trim()) {
      dispatch(setNavBarInputFields({ location: searchValue }));
      sessionStorage.setItem("location", searchValue);
      setOpen(false);
    }
  };

  const handleUseCurrentLocation = () => {
    dispatch(setNavBarInputFields({ location: currentLocation }));
    sessionStorage.setItem("location", currentLocation);
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="location-modal"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "70%", sm: "400px" },
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "4px",
          p: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textAlign: "center",
            fontWeight: "500",
            mb: 2,
            color: "primary.main",
          }}
        >
          Set Location
        </Typography>

        <TextField
          fullWidth
          placeholder="Enter Location Here"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          sx={{ mb: 2 }}
        />

        <Divider sx={{ my: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Or
          </Typography>
        </Divider>

        <Button
          fullWidth
          variant="outlined"
          startIcon={<MyLocationIcon />}
          onClick={handleUseCurrentLocation}
          sx={{
            mb: 3,
            py: 1.5,
            textTransform: "none",
            fontSize: { sm: "1rem", xs: "14px" },
          }}
        >
          Use Current Location
        </Button>

        <Stack direction="row" spacing={2} justifyContent="center">
          <Button
            variant="outlined"
            onClick={() => setOpen(false)}
            sx={{
              flex: 1,
              textTransform: "none",
              fontSize: { sm: "1rem", xs: "14px" },

              py: 1,
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={!searchValue.trim()}
            sx={{
              flex: 1,
              textTransform: "none",
              fontSize: { sm: "1rem", xs: "14px" },
              py: 1,
            }}
          >
            Set
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default LocationModal;